import { Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AssetOccupancy } from './Occupancy';
import { ContractTypeSelector } from '../atomic-components/ContractTypeSelector';
import { ContractStartDatePicker } from '../atomic-components/ContractStartDatePicker';
import { ContractEndDatePicker } from '../atomic-components/ContractEndDatePicker';
import { LandRegisterMortgageStatusText } from '../atomic-components/LandRegisterMortgageStatusText';
import { LandRegisterMortgageDeclaration } from '../atomic-components/LandRegisterMortgageDeclaration';
import { AssetTypeConditional } from '../../user/AssetTypeConditional';
import { RentalStartDatePicker } from '../atomic-components/RentalStartDatePicker';

interface Props {
  disabled: boolean;
}

export const AssetRentalInformation: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Typography gutterBottom variant="h6">
        {t('dashboard.assets.addedit.main.rentalinformation.title')}
      </Typography>
      <ContractTypeSelector disabled={disabled} />
      <ContractStartDatePicker disabled={disabled} />
      <AssetTypeConditional supported={['builderOwnerModel']}>
        <RentalStartDatePicker disabled={disabled} />
      </AssetTypeConditional>
      <ContractEndDatePicker disabled={disabled} />
      <AssetOccupancy disabled={disabled} />
      <LandRegisterMortgageStatusText disabled={disabled} />
      <LandRegisterMortgageDeclaration disabled={disabled} />
    </div>
  );
};
